import { jsx as _jsx } from "react/jsx-runtime";
import hotToast from 'react-hot-toast';
import { ExclamationCircleIcon } from '@repo/icons';
import CustomToast from '../components/CustomToast';
import { getLabels } from '../labels';
import { resolveToastId } from '../utils/resolveToastId';
export const danger = (message, testId, options) => {
    const id = resolveToastId('danger', message, options);
    const resolvedOptions = id ? { ...options, id } : options;
    const labels = getLabels();
    return hotToast.custom((toast) => (_jsx(CustomToast, { message: message, hotToast: hotToast, isVisible: toast.visible, id: toast.id, className: "bg-danger-soft border-stroke-danger-subtle text-danger-strong", defaultIcon: _jsx(ExclamationCircleIcon, { size: 20 }), testId: testId, closeLabel: labels.close, options: options })), resolvedOptions);
};
